import { Button, ButtonProps, CircularProgress } from "@mui/material";
import { useFormContext } from "../../../contexts/form-context";
import useStore from "../../../hooks/use-store";
import { useSubmitButton } from "../../../modules/field-set";

export default function FormSubmitButton({
    name,
    variant = "contained",
    children,
    ...props
}: ButtonProps) {
    const form = useFormContext();
    const submit = useSubmitButton({ name });

    const [isSubmitting, canSubmit] = useStore(form.store, state => [state.isSubmitting, state.canSubmit])

    const disabled = submit.fieldSet.disabled || isSubmitting || !canSubmit || props.disabled;
    const loading = isSubmitting && submit.isSubmitting;

    return <Button
        {...props}
        ref={submit.ref as any}
        onClick={e => {
            props.onClick && props.onClick(e);
            if (!e.defaultPrevented) submit.submit();
        }}
        disabled={disabled}
        variant={variant}
        sx={{ position: "relative", ...props.sx }}
    >
        {loading ? <CircularProgress size={"25px"} /> : children}
    </Button>
}